
<div class="icon-cont">
  <a class="social-icon" target="_blank" rel="noopener" href="{{componentData.url}}">
    <i class="fa-brands fa-x-twitter"></i>
  </a>
</div>